import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { SharedNavBar, NavData } from 'Guide/PageNavigation/SharedNavBar';

export function DocumentNav(props: NavData) {
   const { breadCrumbs, navTabs } = props;

   return <SharedNavBar breadCrumbs={breadCrumbs} navTabs={navTabs} />;
}

initializeChakraComponent('DocumentNavComponent', DocumentNav);
